import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Main from "./pages/Landing/Main";
import Fitting from "./pages/Fitting/index";
import { Provider } from "./context/FittingContext";
import { FeatureFlagProvider } from "./context/FeatureFlagContext";
import FeatureFlagBanner from "./components/FeatureFlagBanner";
function App() {
	return (
		<FeatureFlagProvider>
			<Provider>
				<Router>
					<Routes>
						<Route path="/" element={<Main />} />
						<Route path="/fitting" element={<Fitting />} />
					</Routes>
				</Router>
			</Provider>
		</FeatureFlagProvider>
	);
}

export default App;
